import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-673553a0"), n = n(), _popScopeId(), n);
const _hoisted_1 = ["onClick"];
import { ref, computed } from "vue";
import draggable from "vuedraggable";
import Strings from "src/shared/Strings";
export default /*#__PURE__*/ _defineComponent({
    __name: 'AllowedValuesDraggableList',
    props: {
        list: {},
        isColumnFlow: { type: Boolean }
    },
    emits: ["update:list", "remove"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const drag = ref(false);
        const isActive = ref(false);
        const emit = __emit;
        const listProxy = computed({
            get: () => {
                const parsedSelectedOptions = props.list.map((value) => ({
                    id: value,
                    value,
                }));
                return parsedSelectedOptions;
            },
            set: (value) => {
                emit("update:list", value.map((value) => value.value));
            },
        });
        const toggleActiveStyle = () => {
            isActive.value = !isActive.value;
        };
        const dragOptions = computed(() => ({
            animation: 150,
            group: "description",
            disabled: false,
            ghostClass: "ghost",
        }));
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(_unref(draggable), _mergeProps({
                class: ["list-group", { 'column-flow': _ctx.isColumnFlow }],
                "component-data": {
                    tag: 'ul',
                    type: 'transition-group',
                    name: !drag.value ? 'flip-list' : null,
                },
                "hover-class": "hover",
                modelValue: listProxy.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((listProxy).value = $event))
            }, dragOptions.value, {
                onStart: _cache[1] || (_cache[1] = ($event) => (drag.value = true)),
                onEnd: _cache[2] || (_cache[2] = ($event) => (drag.value = false)),
                "item-key": "id"
            }), {
                item: _withCtx(({ element }) => [
                    _createElementVNode("div", {
                        onMousedown: toggleActiveStyle,
                        onMouseup: toggleActiveStyle,
                        class: "manageable-list list-group-item"
                    }, [
                        _createElementVNode("span", null, _toDisplayString(_unref(Strings).capitalize(element.value)), 1 /* TEXT */),
                        _createElementVNode("i", {
                            class: "fal fa-trash",
                            onClick: ($event) => (emit('remove', element.value))
                        }, null, 8 /* PROPS */, _hoisted_1)
                    ], 32 /* NEED_HYDRATION */)
                ]),
                _: 1 /* STABLE */
            }, 16 /* FULL_PROPS */, ["class", "component-data", "modelValue"]));
        };
    }
});
